import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateTrainingBasicinfoDocument,
  UpdateTrainingBasicinfoMutation,
  UpdateTrainingBasicinfoMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingBasicinfoMutation,
  UpdateTrainingBasicinfoMutationVariables
>

export const useUpdateTrainingBasicInfo = (options?: Options) => {
  const [updateBasicInfoTraining, { loading }] = useMutation(UpdateTrainingBasicinfoDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateBasicInfoTrainingsTraining,
  })

  return {
    loading,
    updateBasicInfoTraining(variables: UpdateTrainingBasicinfoMutationVariables) {
      return updateBasicInfoTraining({
        variables,
      })
    },
  }
}
